import { render, staticRenderFns } from "./Hospitalization.vue?vue&type=template&id=47ce1b1f"
import script from "./Hospitalization.vue?vue&type=script&lang=js"
export * from "./Hospitalization.vue?vue&type=script&lang=js"
import style0 from "./Hospitalization.vue?vue&type=style&index=0&id=47ce1b1f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports